// DASHBOARD WORKING CODE
import React, { useEffect, useMemo, useRef, useState } from "react";
import { Link } from "react-router-dom";
import ImageWithBasePath from "../../core/common/imageWithBasePath";
import { all_routes } from "../router/all_routes";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import CollapseHeader from "../../core/common/collapse-header/collapse-header";
import axios from "axios";
import { apibaseurl, jwttoken } from "../../environment";
import useApi from "../../core/customhook/useApi";
import Chart from "react-apexcharts";
import { ApexOptions } from "apexcharts";
import HolidayCalendar from "../mainMenu/employeeDashboard/holidayCalender";
import Table from "../../core/common/dataTable/index";
import DashboardAnnouncements from "../mainMenu/employeeDashboard/DashboardAnnouncements ";
import Loader from "../../core/common/selfLoder";
import dayjs from "dayjs";

interface EmployeeProfile {
  employee_name: string;
  designation: string;
  department: string;
  sub_department: string;
  email_id: string;
  contact_number: string;
  join_date: string;
  photo: string | null;
  work_location: string;
  band: string;
  employee_id: string;
}
interface LeaveSummary {
  status: string;
  total: number;
}
interface MonthlyLeaveSummary {
  status: string;
  total: number;
}
interface EmployeeHourlyRcord {
  total_hours_today: string;
  total_hours_this_week: string;
  total_hours_overall: string;
  overtime: string;
}

interface Task {
  ID: number;
  task: string;
  department: string;
  status: string;
  favourite: number;
}

interface TeamMember {
  ID?: number;
  employee_id?: string;
  designation?: string;
  employee_name?: string;
  email_id?: string;
  band?: string;
  department?: string;
  photo?: string | null;
}

interface Project {
  ID?: number;
  project_id?: string;
  title?: string;
  deadline?: any;
  status?: string;
  team?: TeamMember[];
}

export interface TicketScheduleItem {
  action_by: string;
  action_type: string;
  old_value: string | null;
  new_value: string | null;
  comments: string;
  created_at: string;
  employee_name: string;
  department: string;
}

export interface TicketScheduleData {
  ticket_id: string;
  created_at: string;
  schedule: TicketScheduleItem[];
}

export interface TicketHistoryResponse {
  success: boolean;
  message: string;
  statusCode: number;
  data: TicketScheduleData;
}

export interface BirthdayMember {
  employee_id: string;
  email_id: string;
  employee_name: string;
  gender: string;
  designation: string;
  photo: string;
}

export interface BirthdayApiResponse {
  success: boolean;
  statusCode: number;
  message: string;
  data: BirthdayMember[];
}

const EmployeeDashboard = () => {
  const routes = all_routes;
  const leaveModalRef = useRef<HTMLDivElement | null>(null);
  const [selectedYear, setSelectedYear] = useState<number>(
    new Date().getFullYear(),
  );
  const [employeeData, setEmployeeData] = useState<EmployeeProfile | null>(
    null,
  );

  const [employeeLeaveMonth, setEmployeeLeaveMonth] = useState<
    MonthlyLeaveSummary[]
  >([]);
  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: 2 }, (_, index) => currentYear - index);

  let total_leaves = 0;
  let absent = 0;
  let Worked_Days = 0;
  let Taken = 0;
  let half_day = 0;
  employeeLeaveMonth.map((item, index) => {
    if (
      item.status === "absent" ||
      item.status === "sick_leave" ||
      item.status === "leave"
    ) {
      total_leaves += item.total;
    }
    if (item.status === "absent") absent += item.total;
    if (item.status === "present" || item.status === "half_day")
      Worked_Days += item.total;
    if (item.status === "sick_leave" || item.status === "leave")
      Taken += item.total;
    if (item.status === "half_day") half_day += item.total;
  });

  const expense = [
    {
      title: "Title",
      dataIndex: "title",
    },
    {
      title: "Amount",
      dataIndex: "amount", // merged currency + amount
    },
    {
      title: "Date",
      dataIndex: "date",
      render: (text: string) =>
        text ? dayjs(text, "DD-MM-YYYY").format("D MMMM YYYY") : "N/A",
    },
    {
      title: "Status",
      dataIndex: "status",
      render: (status: string) => {
        let color = "black"; // default color

        switch (status.toLowerCase()) {
          case "approved":
            color = "green";
            break;
          case "rejected":
            color = "red";
            break;
          case "pending":
            color = "orange";
            break;
          default:
            color = "black";
        }

        return <span style={{ color }}>{status}</span>;
      },
    },
  ];

  // Financial year logic:
  const getCurrentFinancialYear = () => {
    const today = new Date();
    const year = today.getFullYear();
    const nextYearShort = (year + 1).toString().slice(-2);
    return `${year}-${nextYearShort}`;
  };

  const formatFinancialYear = (year: number) => {
    const nextYearShort = (year + 1).toString().slice(-2);
    return `${year}-${nextYearShort}`;
  };

  const getFinancialYear = () => {
    const today = new Date();
    const year = today.getFullYear();
    return formatFinancialYear(year);
  };

  const [finance_year, setFinance_year] = useState(getFinancialYear());

  // PROFILE OVERVIEW
  const getEmployeeRecord = async () => {
    const token = jwttoken;
    try {
      const response = await axios.get(
        `${apibaseurl}/api/get-profile-overview`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
      if (response.data.statusCode === 200) {
        setEmployeeData(response.data.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getEmployeeRecord();
  }, []);

  const [series, setSeries] = useState<number[]>([]); // 🔹 default empty
  const [labels, setLabels] = useState<string[]>([]); // labels

  // Leave Details
  const {
    data: leave_Balance_data,
    loading: leave_balance_loading,
    error: leave_balance_error,
  } = useApi("/api/view-leave-balance-dashboard", {
    method: "POST",
    payload: {
      financial_year: `${selectedYear}-${(Number(selectedYear) + 1)
        .toString()
        .slice(-2)}`,
    },
    autoCall: true,
    dependencies: [selectedYear],
  });

  // const [options, setOptions] = useState<ApexOptions>({
  //   chart: {
  //     type: "pie",
  //     height: 250,
  //     toolbar: { show: false },
  //   },
  //   labels: [], // 🔹 will update dynamically
  //   legend: { show: false, position: "bottom" },
  //   dataLabels: { enabled: false },
  //   tooltip: {
  //     y: {
  //       formatter: (val: number) => (val < 0.01 ? "0" : val.toFixed(1)),
  //     },
  //   },
  //   colors: [
  //     "#343a40",
  //     "#198754",
  //     "#dc3545",
  //     "#ffc107",
  //     "#0d6efd",
  //     "#6f42c1",
  //     "#fd7e14",
  //     "#20c997",
  //     "#6610f2",
  //   ],
  // });

  // Update from API

  const [options, setOptions] = useState<ApexOptions>({
    chart: {
      type: "pie",
      height: 250,
      toolbar: { show: false },
    },

    labels: ["Availed Leave", "Available Leave"],

    legend: { show: false, position: "bottom" },

    dataLabels: { enabled: false },

    tooltip: {
      y: {
        formatter: (val: number) => (val < 0.01 ? "0" : val.toFixed(1)),
      },
    },

    colors: ["#dc3545", "#198754"], // 🔴 Red , 🟢 Green
  });

  useEffect(() => {
    if (leave_Balance_data?.data && Array.isArray(leave_Balance_data.data)) {
      const balances = leave_Balance_data.data.map((item: any) => {
        const closing_balance = parseFloat(item.closing_balance) || 0;
        return closing_balance === 0 ? 0.0001 : closing_balance;
      });
      console.log(balances, "balances");

      const apiLabels = leave_Balance_data.data.map(
        (item: any) => item.leave_type || "Unknown",
      );

      setSeries(balances);
      setLabels(apiLabels);

      // update chart options with new labels
      setOptions((prev) => ({
        ...prev,
        labels: apiLabels,
      }));

      console.log("Chart Data:", { balances, apiLabels });
    }
  }, [leave_Balance_data]);

  const {
    data: advanseExpenseData,
    loading: advanseExpenseLoading,
    error: advanseExpenseError,
    callApi: getAdvanseData, // ✅ name the function
  } = useApi("/api/expenses/view", {
    method: "POST",
    autoCall: false,
  });

  useEffect(() => {
    const expc_category_id = "EXPC20251001";
    getAdvanseData({ expc_category_id }); // ✅ call the API with params
  }, []);

  const formatAmount = (amount: any) =>
    new Intl.NumberFormat("en-IN").format(amount);

  const expensedataUpdate = useMemo(() => {
    if (!advanseExpenseData?.data) return [];
    return advanseExpenseData.data.map((item: any, index: number) => ({
      key: index + 1,
      title: item.expc_title,
      amount: `${item.currency_name.split(" ")[0]} ${formatAmount(
        item.amount,
      )}`,
      date: item.expc_date,
      status: item.status,
    }));
  }, [advanseExpenseData]);

  // Jobs Post
  const {
    data: AllJobsData,
    loading: AllJobsLoading,
    error: AllJobsError,
    // callApi: getAdvanseData,
  } = useApi("/api/ijp", {
    method: "POST",
    autoCall: true,
  });

  useEffect(() => {
    console.log(AllJobsData?.data, "AllJobsData");
  }, [AllJobsData]);

  const openings = [
    {
      id: 1,
      title: "Full Stack - Sales",
      location: "Delhi",
      experience: "2–5 years of experience",
      type: "Permanent",
      icon: "assets/img/icons/apple.svg",
    },
    {
      id: 2,
      title: "FrontEnd Dev - IT",
      location: "New Delhi",
      experience: "1–2 years of experience",
      type: "Permanent",
      icon: "assets/img/icons/apple.svg",
    },
  ];

  // my job Refreal
  const {
    data: JobRefrealData,
    loading: JobRefrealLoading,
    error: JobRefrealError,
    // callApi: getAdvanseData,
  } = useApi("/api/reffered-friend-list", {
    method: "GET",
    autoCall: true,
  });

  useEffect(() => {
    // console.log(JobRefrealData?.data, "SupportTeamData");
  }, [JobRefrealData]);

  const {
    data: AnnouncementData2,
    loading: AnnouncementLoading2,
    error: AnnouncementError2,
    // callApi: getAdvanseData,
  } = useApi("/api/get-announcement", {
    method: "GET",
    autoCall: true,
  });

  useEffect(() => {
    console.log(AnnouncementData2?.data, "/api/thoughts/view");
  }, [AnnouncementData2]);

  // /*********************AnnouncementData*****
  const {
    data: AnnouncementData,
    loading: AnnouncementLoading,
    error: AnnouncementError,
    // callApi: getAdvanseData,
  } = useApi("/api/thoughts/view", {
    method: "GET",
    autoCall: true,
  });

  useEffect(() => {
    console.log(AnnouncementData?.data, "/api/thoughts/view");
  }, [AnnouncementData]);

  // /*********************engagement-activity*****
  const {
    data: EngagementActivityData,
    loading: EngagementActivityLoading,
    error: EngagementActivityError,
    // callApi: getAdvanseData,
  } = useApi("/api/engagement-activity", {
    method: "GET",
    autoCall: true,
  });

  useEffect(() => {
    console.log(EngagementActivityData?.data, "engagement-activity");
  }, [AnnouncementData]);

  //******************************/ Team Members
  const {
    data: TeamMembersData,
    loading: TeamMembersLoading,
    error: TeamMembersError,
    // callApi: getAdvanseData,
  } = useApi("/api/get-colleague-employee", {
    method: "GET",
    autoCall: true,
  });

  useEffect(() => {
    // console.log(TeamMembersData, "TeamMembersData");
  }, [TeamMembersData]);

  // **************************** Support Team
  const {
    data: SupportTeamData,
    loading: SupportTeamLoading,
    error: SupportTeamError,
    // callApi: getAdvanseData,
  } = useApi("/api/get-support-team", {
    method: "GET",
    autoCall: true,
  });

  useEffect(() => {
    // console.log(SupportTeamData?.data, "SupportTeamData");
  }, [SupportTeamData]);

  const {
    data: apiData,
    loading,
    error,
  } = useApi("/api/employees/message/view", {
    method: "GET",
    autoCall: true,
  });

  // *********************************** Birthday Api
  const {
    data: birthdayeData,
    loading: birthdayeLoading,
    error: birthdayeError,
  } = useApi<BirthdayApiResponse>("/api/get-teams-birthday", {
    method: "GET",
    autoCall: true,
  });

  const birthdayList = birthdayeData?.data ?? [];
  useEffect(() => {
    // console.log(birthdayeData?.data, "birthdayeData...........");
  }, [birthdayeData]);

  const leaveColors = [
    "#fd7e14", // Sick Leave
    "#0d6efd", // Restricted Holiday
    "#6f42c1", // Earned Leave
    "#ffc107", // Maternity Leave
    "#0d6efd", // Leave Without Pay
    "#6f42c1", // Special Holiday Leave
    "#fd7e14", // Bereavement Leave
    "#20c997", // Wedding Leave
    "#6610f2", // Hospitalization Leave
  ];

  // Utility function to get birthday with current year
  const getNextBirthday = (dob: string) => {
    const [day, month] = dob.split("/").map(Number);
    const today = new Date();
    let birthdayThisYear = new Date(today.getFullYear(), month - 1, day);

    // If birthday already passed this year, use next year
    if (birthdayThisYear < today) {
      birthdayThisYear = new Date(today.getFullYear() + 1, month - 1, day);
    }

    // Format as dd-mm-yyyy
    const formatted = birthdayThisYear.toLocaleDateString("en-GB");
    return formatted; // e.g., "18-10-2025"
  };

  const formatDate = (date: string | null) => {
    if (!date) return "";
    const d = new Date(date);
    return d.toLocaleDateString("en-GB", {
      day: "numeric",
      month: "long",
      year: "numeric",
    });
  };

  const formatDateDDMMYYY = (date: string | null) => {
    if (!date) return "";

    const [day, month, year] = date
      .split("/")
      .map((part) => parseInt(part, 10));
    if (!day || !month || !year) return "";

    const d = new Date(year, month - 1, day); // JS months are 0-based

    return d.toLocaleDateString("en-GB", {
      day: "numeric",
      month: "long",
      year: "numeric",
    });
  };

  const formatBirthdayCurrentYear = (dob: string) => {
    // dob is in format "dd/mm/yyyy"
    const [dayStr, monthStr, yearStr] = dob.split("/");
    const day = parseInt(dayStr, 10);
    const month = parseInt(monthStr, 10) - 1; // JS months are 0-indexed
    const currentYear = new Date().getFullYear();

    const date = new Date(currentYear, month, day);

    // Format as "1 January 2026"
    const formattedDay = date.getDate();
    const formattedMonth = date.toLocaleString("en-US", { month: "long" });

    return `${formattedDay} ${formattedMonth} ${currentYear}`;
  };

  const formatBirthdayLabel = (dob: string) => {
    const [dayStr, monthStr] = dob.split("/"); // ignore the year from API
    const day = parseInt(dayStr, 10);
    const month = parseInt(monthStr, 10) - 1; // JS months are 0-indexed
    const currentYear = new Date().getFullYear();

    const birthdayThisYear = new Date(currentYear, month, day);
    const today = new Date();
    today.setHours(0, 0, 0, 0); // reset time
    const tomorrow = new Date(today);
    tomorrow.setDate(today.getDate() + 1);

    if (birthdayThisYear.getTime() === today.getTime()) return "Today";
    if (birthdayThisYear.getTime() === tomorrow.getTime()) return "Tomorrow";

    const formattedDay = birthdayThisYear.getDate();
    const formattedMonth = birthdayThisYear.toLocaleString("en-US", {
      month: "long",
    });
    return `${formattedDay} ${formattedMonth} ${currentYear}`;
  };

  return (
    <>
      <Loader
        loading={
          leave_balance_loading ||
          advanseExpenseLoading ||
          AllJobsLoading ||
          JobRefrealLoading ||
          AnnouncementLoading2 ||
          AnnouncementLoading ||
          EngagementActivityLoading ||
          TeamMembersLoading ||
          SupportTeamLoading ||
          birthdayeLoading
        }
      />
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2">
              <h2 className="mb-1">Employee Dashboard </h2>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={routes.employeeDashboard}>
                      <i className="ti ti-smart-home" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item">Dashboard</li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Employee Dashboard
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
              <div className="me-2 mb-2"></div>
              <div className="ms-2 head-icons">
                <CollapseHeader />
              </div>
            </div>
          </div>
          {!AnnouncementLoading &&
            !AnnouncementError &&
            AnnouncementData?.data?.length > 0 && (
              <div className="row">
                <div className="col-md-12">
                  <div className="card shadow-sm border-0">
                    <DashboardAnnouncements
                      announcements={AnnouncementData.data}
                    />
                  </div>
                </div>
              </div>
            )}
          <div className="row">
            {/* Profile Details Section */}
            <div className="col-md-4 d-flex">
              <div className="card position-relative flex-fill">
                <div className="card-header custom_button">
                  <div className="d-flex justify-content-between align-items-center">
                    {/* Left Side: Image + Details */}
                    <div className="d-flex align-items-center">
                      <span className="avatar avatar-lg avatar-rounded border border-white border-2 flex-shrink-0 me-2">
                        <ImageWithBasePath
                          src={
                            employeeData?.photo ||
                            "./assets/img/logo/profilepic.jpg"
                          }
                          alt="Img"
                        />
                      </span>

                      <div>
                        <h5 className="text-white mb-1">
                          {employeeData?.employee_name}
                        </h5>

                        {employeeData?.designation && (
                          <p className="text-white fs-13 mb-1">
                            {employeeData?.designation}
                          </p>
                        )}

                        {(employeeData?.sub_department ||
                          employeeData?.department) && (
                          <p className="fs-12 text-white mb-0">
                            {employeeData?.sub_department}
                          </p>
                        )}
                      </div>
                    </div>

                    {/* Right Side: Button */}
                    {/* <div>
                      <Link
                        to="/pages/profile"
                        className="btn btn-light btn-sm"
                      >
                        View Profile
                      </Link>
                    </div> */}
                  </div>
                </div>

                <div className="card-body">
                  {/* Employee ID */}
                  <div className="mb-2">
                    <span className="d-block mb-1 fs-13">Employee ID</span>
                    <p className="text-gray-9">{employeeData?.employee_id}</p>
                  </div>

                  {/* Email */}
                  <div className="mb-2">
                    <span className="d-block mb-1 fs-13">Email Address</span>
                    <p className="text-gray-9">{employeeData?.email_id}</p>
                  </div>

                  {/* DOJ */}
                  <div className="mb-2">
                    <span className="d-block mb-1 fs-13">Joined On</span>
                    <p className="text-gray-9">
                      {formatDateDDMMYYY(employeeData?.join_date || "")}
                    </p>
                  </div>

                  {/* View Full Profile Button */}

                  <div className="d-flex justify-content-end mt-2">
                    <Link
                      to="/pages/profile"
                      className="btn btn-primary btn-sm"
                    >
                      View Profile
                    </Link>
                  </div>
                </div>
              </div>
            </div>
            {/* Profile Details section */}

            {/* Yearly Leave Section */}
            <div className="col-md-8 d-flex">
              <div className="card flex-fill">
                <div className="card-header">
                  <div className="d-flex align-items-center justify-content-between flex-wrap row-gap-2">
                    <h5>
                      {" "}
                      <i
                        className="ti ti-chart-donut text-primary me-1"
                        style={{ fontSize: "25px", fontWeight: "600" }}
                      ></i>
                      Leave Balance{" "}
                    </h5>
                    <div className="dropdown">
                      <Link
                        to="#"
                        className="btn btn-white border btn-sm d-inline-flex align-items-center"
                        data-bs-toggle="dropdown"
                      >
                        <i className="ti ti-calendar me-1" />
                        {selectedYear}
                      </Link>
                      <ul
                        className="dropdown-menu dropdown-menu-end p-3"
                        style={{ maxHeight: "250px", overflowY: "auto" }}
                      >
                        {years.map((year) => (
                          <li key={year}>
                            <Link
                              to="#"
                              className="dropdown-item rounded-1"
                              onClick={() => setSelectedYear(year)}
                            >
                              {year}
                            </Link>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="card-body">
                  {leave_Balance_data?.data?.length > 0 ? (
                    <div className="row align-items-center">
                      {/* LEFT : Leave List */}
                      <div className="col-md-4 border-end">
                        {leave_Balance_data.data.map(
                          (leave: any, idx: number) => {
                            const balance =
                              parseFloat(leave.opening_balance) +
                                parseFloat(leave.prorata_balance) || 0;

                            return (
                              <div
                                key={leave.leave_wallet_id}
                                className="d-flex align-items-center justify-content-between mb-3"
                              >
                                <div className="d-flex align-items-center gap-2">
                                  <span
                                    style={{
                                      width: 10,
                                      height: 10,
                                      borderRadius: "50%",
                                      background: leaveColors[idx],
                                      display: "inline-block",
                                    }}
                                  />
                                  <span className="fw-semibold">
                                    {leave.leave_type}
                                  </span>
                                </div>

                                <span className="fw-bold text-primary">
                                  {balance.toFixed(1)}
                                </span>
                              </div>
                            );
                          },
                        )}
                      </div>

                      {/* RIGHT : Charts */}
                      <div className="col-md-8">
                        <div className="row">
                          {leave_Balance_data.data.map(
                            (leave: any, idx: number) => (
                              <div
                                key={idx}
                                className="col-md-4 text-center mb-3"
                              >
                                <Chart
                                  options={options}
                                  series={[
                                    parseFloat(leave.availed_balance) || 0,
                                    parseFloat(leave.closing_balance) || 0,
                                  ]}
                                  type="donut"
                                  height={180}
                                />
                                <small className="fw-semibold d-block mt-2">
                                  {leave.leave_type}
                                </small>
                              </div>
                            ),
                          )}
                        </div>
                        <div className="d-flex justify-content-end mt-2">
                          <Link
                            to="/leave-application"
                            className="btn btn-primary btn-sm"
                          >
                            Apply Leave
                          </Link>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div className="text-center text-muted py-4">
                      No leave balance data available
                    </div>
                  )}
                </div>
              </div>
            </div>
            {/* Recent Activities */}
            <div className="col-md-4 d-flex">
              <div className="card flex-fill">
                <div className="card-header pb-2 d-flex align-items-center justify-content-between flex-wrap">
                  <h5 className="mb-2">
                    <i
                      className="ti ti-activity text-success me-1"
                      style={{ fontSize: "25px", fontWeight: "600" }}
                    ></i>
                    Upcoming Activities{" "}
                  </h5>
                  <Link
                    to="/engagement-calendar"
                    className="btn btn-light btn-md mb-2"
                  >
                    View All
                  </Link>
                </div>
                <div className="card-body">
                  {EngagementActivityData?.data.length > 0 ? (
                    EngagementActivityData?.data
                      .slice(0, 3)
                      .map((activity: any, idx: number) => (
                        <div key={idx} className="mb-3 border-bottom pb-2">
                          <p className="mb-1" style={{ fontWeight: "600" }}>
                            {activity.activity_name} ({activity.activity_type})
                          </p>
                          <small className="text-muted">
                            {formatDate(activity.activity_fromdate)}{" "}
                            {activity.activity_todate &&
                              `– ${formatDate(activity.activity_todate)}`}
                          </small>
                        </div>
                      ))
                  ) : (
                    <p className="text-muted mb-0">No upcoming activities</p>
                  )}
                </div>
              </div>
            </div>
            <div className="col-md-4 d-flex">
              <div className="row flex-fill">
                <div className="card">
                  <div className="card-header ps-2">
                    <div className="d-flex align-items-center justify-content-between flex-wrap row-gap-2">
                      <h5 className="mb-0">
                        <i
                          className="ti ti-speakerphone text-danger me-1"
                          style={{ fontSize: "25px", fontWeight: "600" }}
                        ></i>
                        Announcements
                      </h5>
                      <div className="dropdown">
                        <Link
                          to="/announcements"
                          className="btn btn-light btn-md mb-2"
                        >
                          View All
                        </Link>
                      </div>
                    </div>
                  </div>
                  <div className="card-body p-0">
                    {AnnouncementData2?.data?.length > 0 ? (
                      <ul className="list-group list-group-flush">
                        {AnnouncementData2.data
                          .slice(0, 3)
                          .map((item: any, index: number) => (
                            <li key={index} className="list-group-item my-1">
                              <div style={{ fontWeight: 500 }}>
                                📢 {item.announcement}
                              </div>
                              <div className="text-muted d-flex justify-content-end mt-1">
                                {formatDate(item.created_date)}
                              </div>
                            </li>
                          ))}
                      </ul>
                    ) : (
                      <div className="text-center text-muted p-3">
                        No announcements available
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-4 d-flex">
              <div className="card flex-fill">
                <div className="card-header pb-2 d-flex align-items-center justify-content-between flex-wrap">
                  <h5 className="mb-2">
                    <i
                      className="ti ti-cake me-1 text-warning"
                      style={{ fontSize: "25px", fontWeight: "600" }}
                    ></i>
                    Birthdays{" "}
                  </h5>
                  <Link to="/we-talk" className="btn btn-light btn-md mb-2">
                    View All
                  </Link>
                </div>

                <div className="card-body pb-1">
                  {birthdayList?.length > 0 ? (
                    birthdayList
                      ?.slice(0, 3)
                      .map((person: any, index: number) => (
                        <div key={index}>
                          {/* <h6 className="mb-2"> {person.date_of_birth}</h6> */}
                          {/* <h6 className="mb-2">
                            {formatDateDDMMYYY(person.date_of_birth)}
                          </h6> */}
                          <div className="bg-light p-2 border border-dashed rounded-top mb-3">
                            <div className="d-flex align-items-center justify-content-between">
                              <div className="d-flex align-items-center px-2">
                                <span className="avatar">
                                  <ImageWithBasePath
                                    src={
                                      person.photo ||
                                      "https://cdn-icons-png.flaticon.com/512/149/149071.png"
                                    }
                                    className="rounded-circle"
                                    alt={person.employee_name}
                                  />
                                </span>
                                <div className="ms-3 overflow-hidden">
                                  <Link to="/we-talk">
                                    <h6 className="fs-medium">
                                      {person.employee_name} 🎉🎈
                                    </h6>
                                    <p className="fs-13">
                                      {formatBirthdayCurrentYear(
                                        person.date_of_birth,
                                      )}
                                    </p>
                                  </Link>
                                  {/* <div>
                                     <p className="fs-13">
                                      {formatBirthdayLabel(
                                        person.date_of_birth,
                                      )}
                                    </p>
                                  </div> */}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))
                  ) : (
                    <p className="text-muted text-center">
                      No team members have a birthday today.
                    </p>
                  )}
                </div>
              </div>
            </div>
            {/* Monthly Leave Section */}
          </div>
          {/* row 2 Holiday Calendar and Leave Details */}
          <div className="row">
            <div className="col-xl-7 d-flex ">
              <div className="card flex-fill bg-white">
                <div className="card-header ">
                  <div className="d-flex align-items-center justify-content-between flex-wrap row-gap-2 ">
                    <h5 className="mb-0">
                      <i
                        className="ti ti-calendar-event text-warning me-1"
                        style={{ fontSize: "25px", fontWeight: "600" }}
                      ></i>
                      Holiday Calendar{" "}
                    </h5>
                  </div>
                </div>
                <div className="card-body">
                  <HolidayCalendar />
                </div>
              </div>
            </div>
            <div className="col-md-5 d-flex">
              <div className="card flex-fill shadow-sm">
                <div className="card-header d-flex align-items-center justify-content-between">
                  <h5
                    className="mb-0 d-flex align-items-center gap-2"
                    style={{ fontWeight: 600 }}
                  >
                    <i
                      className="ti ti-chat-quote text-warning"
                      style={{ fontSize: "25px" }}
                    ></i>
                    <span
                      role="img"
                      aria-label="sun"
                      style={{ fontSize: "20px" }}
                    >
                      🌞
                    </span>{" "}
                    Employee Speak
                  </h5>
                  <Link to="/employee-speak" className="btn btn-light btn-sm">
                    View All
                  </Link>
                </div>

                <div className="card-body">
                  {apiData?.data.slice(0, 3).map((msg: any) => {
                    // Convert HTML to text for word counting
                    const tempDiv = document.createElement("div");
                    tempDiv.innerHTML = msg.emp_message;
                    const textContent =
                      tempDiv.textContent || tempDiv.innerText || "";

                    // Get first 20 words
                    const words = textContent
                      .split(/\s+/)
                      .slice(0, 35)
                      .join(" ");
                    const isTruncated = textContent.split(/\s+/).length > 20;

                    return (
                      <div
                        key={msg.ID}
                        className="d-flex flex-column gap-2 mb-4"
                      >
                        {/* Header: Image + Name + Date */}
                        <div className="d-flex justify-content-between align-items-center">
                          {/* User: Image + Name */}
                          <div className="d-flex align-items-center gap-2">
                            <img
                              src={
                                msg.photo ||
                                "https://cdn-icons-png.flaticon.com/512/149/149071.png"
                              }
                              alt={msg.employee_name}
                              className="rounded-circle"
                              width={50}
                              height={50}
                            />
                            <h6 className="mb-0 fw-semibold">
                              <span>{msg.employee_name}</span>
                            </h6>
                          </div>

                          {/* Date */}
                          <span className="text-muted small">
                            {formatDate(msg.created_date)}
                          </span>
                        </div>

                        {/* Message Content */}
                        <div className="emp-message small">
                          {words}
                          {isTruncated && "..."}
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-lg-4 d-flex">
              <div className="card flex-fill">
                <div className="card-header d-flex justify-content-between align-items-center">
                  <h5 className="mb-0 d-flex align-items-center">
                    <i
                      className="ti ti-users text-primary me-2"
                      style={{ fontSize: "22px" }}
                    ></i>
                    Your Team
                  </h5>

                  <Link
                    to="/employee-directory"
                    className="btn btn-light btn-md mb-2"
                  >
                    View All
                  </Link>
                </div>

                <div
                  className="card-body"
                  style={{
                    maxHeight: "400px",
                    overflowY: "auto",
                    paddingRight: "10px",
                  }}
                >
                  {TeamMembersData?.data?.length > 0 ? (
                    TeamMembersData.data.map((member: any, index: number) => (
                      <div
                        key={index}
                        className="d-flex align-items-center justify-content-between mb-4"
                      >
                        <div className="d-flex align-items-center">
                          <Link to="#" className="avatar flex-shrink-0">
                            <ImageWithBasePath
                              src={
                                member.photo ??
                                "https://cdn-icons-png.flaticon.com/512/149/149071.png"
                              }
                              className="rounded-circle border border-2"
                              alt="img"
                            />
                          </Link>
                          <div className="ms-2">
                            <h6 className="fs-14 fw-medium text-truncate mb-1">
                              {/* <Link to="#">{member.employee_name}</Link> */}
                              <a
                                href={`mailto:${member.email}`}
                                className="text-decoration-none"
                              >
                                {member.employee_name}
                              </a>
                            </h6>
                            <p className="fs-13">{member.designation}</p>
                          </div>
                        </div>

                        <div className="text-end">
                          <div className="mt-1 d-flex gap-2 justify-content-end">
                            {/* Call Icon */}
                            <a
                              href={`tel:${member.contact_number}`}
                              className="btn btn-outline-success btn-sm d-flex align-items-center justify-content-center"
                              title="Call"
                            >
                              <i
                                className="ti ti-phone"
                                style={{ fontSize: "18px" }}
                              ></i>
                            </a>

                            {/* Email Icon */}
                            <a
                              href={`mailto:${member.email}`}
                              className="btn btn-outline-primary btn-sm d-flex align-items-center justify-content-center"
                              title="Email"
                            >
                              <i
                                className="ti ti-mail"
                                style={{ fontSize: "18px" }}
                              ></i>
                            </a>
                          </div>
                        </div>
                      </div>
                    ))
                  ) : (
                    <div className="text-center text-muted fs-14 py-4">
                      No Team Member
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="col-lg-4 d-flex">
              <div className="card flex-fill">
                <div className="card-header d-flex justify-content-between align-items-center">
                  <h5 className="mb-0 d-flex align-items-center">
                    <i
                      className="ti ti-headset text-success me-2"
                      style={{ fontSize: "22px" }}
                    ></i>
                    Support Team
                  </h5>

                  <Link
                    to="/support-team"
                    className="btn btn-light btn-md mb-2"
                  >
                    View All
                  </Link>
                </div>

                <div
                  className="card-body"
                  style={{ maxHeight: "400px", overflowY: "auto" }}
                >
                  {SupportTeamData?.data?.length > 0 ? (
                    SupportTeamData.data.map((member: any, index: number) => (
                      <div
                        key={index}
                        className="d-flex justify-content-between align-items-center mb-3"
                      >
                        <div className="d-flex align-items-center">
                          <ImageWithBasePath
                            src={member.photo}
                            className="rounded-circle border me-2"
                            width={40}
                            height={40}
                            alt="img"
                          />

                          <div>
                            <h6 className="fs-14 fw-medium text-truncate mb-1">
                              <a
                                href={`mailto:${member.email_id}`}
                                className="text-dark"
                              >
                                {member.employee_name}
                              </a>
                            </h6>
                            <small className="text-muted">
                              {member.department}
                            </small>
                          </div>
                        </div>

                        <div className="text-end">
                          <div className="mt-1 d-flex gap-2 justify-content-end">
                            {/* Call Icon */}
                            <a
                              href={`tel:${member.contact_number}`}
                              className="btn btn-outline-success btn-sm d-flex align-items-center justify-content-center"
                              title="Call"
                            >
                              <i
                                className="ti ti-phone"
                                style={{ fontSize: "18px" }}
                              ></i>
                            </a>

                            {/* Email Icon */}
                            <a
                              href={`mailto:${member.email_id}`}
                              className="btn btn-outline-primary btn-sm d-flex align-items-center justify-content-center"
                              title="Email"
                            >
                              <i
                                className="ti ti-mail"
                                style={{ fontSize: "18px" }}
                              ></i>
                            </a>
                          </div>
                        </div>
                      </div>
                    ))
                  ) : (
                    <div className="text-center text-muted py-4">
                      No Support Members
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="col-md-4 d-flex">
              <div className="card flex-fill">
                <div className="card-header pb-2 d-flex align-items-center justify-content-between flex-wrap">
                  <h5 className="mb-2">Job Post </h5>
                  <Link to="/jobs" className="btn btn-light btn-md mb-2">
                    View All
                  </Link>
                </div>
                <div className="card-body">
                  <ul
                    className="nav nav-tabs tab-style-1 nav-justified d-sm-flex d-block p-0 mb-4"
                    role="tablist"
                  >
                    <li className="nav-item" role="presentation">
                      <Link
                        className="nav-link fw-medium active"
                        data-bs-toggle="tab"
                        data-bs-target="#openings"
                        aria-current="page"
                        to="#openings"
                        aria-selected="true"
                        role="tab"
                      >
                        All Jobs
                      </Link>
                    </li>
                    <li className="nav-item" role="presentation">
                      <Link
                        className="nav-link fw-medium"
                        data-bs-toggle="tab"
                        data-bs-target="#applicants"
                        to="#applicants"
                        aria-selected="false"
                        tabIndex={-1}
                        role="tab"
                      >
                        My Job Referral
                      </Link>
                    </li>
                  </ul>

                  {/* ✅ Only ONE .tab-content wrapper */}
                  <div className="tab-content">
                    {/* All Jobs */}
                    <div
                      className="tab-pane fade show active"
                      id="openings"
                      role="tabpanel"
                    >
                      {AllJobsData?.data?.length > 0 ? (
                        AllJobsData.data.slice(0, 4).map((opening: any) => (
                          <div
                            key={opening.ID}
                            className="d-flex align-items-center justify-content-between mb-4"
                          >
                            <div className="d-flex align-items-center">
                              <div className="ms-2 overflow-hidden">
                                <p className="text-dark fw-medium text-truncate mb-1">
                                  <Link
                                    to="#"
                                    className="text-decoration-none text-dark"
                                  >
                                    {opening.job_title} - {opening.department}
                                  </Link>
                                </p>
                                <div className="d-flex flex-wrap gap-2 text-muted fs-12">
                                  <span>{opening.job_location}</span>
                                  <span>|</span>
                                  <span>
                                    {opening.experience} Years of Experience
                                  </span>
                                  <span>|</span>
                                  <span>{opening.job_type}</span>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))
                      ) : (
                        <p className="text-muted">No job openings available.</p>
                      )}
                    </div>

                    {/* My Job Referral */}
                    <div
                      className="tab-pane fade"
                      id="applicants"
                      role="tabpanel"
                    >
                      {JobRefrealData?.data?.length > 0 ? (
                        JobRefrealData.data
                          .slice(0, 2)
                          .map((candidate: any) => (
                            <div
                              key={candidate.ID}
                              className="d-flex align-items-center justify-content-between mb-4"
                            >
                              <div className="d-flex align-items-center">
                                <div className="ms-2 overflow-hidden">
                                  <p className="text-dark fw-medium text-truncate mb-0">
                                    <Link
                                      to="#"
                                      className="text-decoration-none text-dark"
                                    >
                                      {candidate.name} (
                                      {candidate.position?.trim()})
                                    </Link>
                                  </p>
                                  <span className="fs-13 d-inline-flex align-items-center text-muted">
                                    Exp: {candidate.year_of_experience} Years
                                    <i className="ti ti-circle-filled fs-4 mx-2 text-success" />
                                    {candidate.phone}
                                  </span>
                                  <br />
                                  <span className="fs-13 text-muted">
                                    {candidate.email}
                                  </span>
                                </div>
                              </div>
                              <div className="d-flex flex-column align-items-end text-end">
                                <a
                                  href={candidate.resume}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className="btn btn-sm btn-outline-primary mt-1"
                                >
                                  View Resume
                                </a>
                              </div>
                            </div>
                          ))
                      ) : (
                        <p className="text-muted">No referrals available.</p>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="footer d-flex align-items-center justify-content-center   border-top bg-white p-3">
          <p className="mb-0">© {new Date().getFullYear()} WeConnect. All rights reserved.</p>
        </div>
      </div>
      {/* /Page Wrapper */}

      {/* Add Leave Modal startinmg */}

      <div className="modal fade" id="add_leaves" ref={leaveModalRef}>
        <div className="modal-dialog modal-dialog-centered modal-md">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">Add Leave</h4>
              <button
                type="button"
                className="btn-close custom-btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Add Leave Modal End */}
    </>
  );
};

export default EmployeeDashboard;
